<template>
  <NavBar />
  <div class="container-fluid course-page">
    <button v-if="preview" type="button" class="calendar-return" @click="$router.back()"><i class="bi bi-arrow-left" aria-hidden="true"></i> Geri dön</button>
    <router-link v-else :to="calendarReturnRoute" class="calendar-return"><i class="bi bi-arrow-left" aria-hidden="true"></i> Takvime dön</router-link>
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="card border-0 rounded-3">
          <div class="card-body">

            <div class="alert alert-warning" v-if="!preview && isPostponed"> {{postponeDateView}} tarihli ders ertelenmiştir. İşlemi geri almak için danışmanınızı arayınız.</div>
            <div class="course-layout">
              <div class="course-sidebar">
                <button class="btn course-menu-toggle" type="button" :aria-expanded="menuOpen" aria-controls="course-navigation" @click="menuOpen = !menuOpen"><i class="bi bi-list me-2"></i>Bölümler · {{ activeTitle }}</button><ul id="course-navigation" class="nav flex-column" :class="{ 'is-open': menuOpen }">
                  <li v-if="bookLevel != null || bookSubject" class="course-book-summary">
                    <div v-if="bookLevel != null" class="course-book-level">
                      <span class="course-book-label">Kitap seviyesi</span>
                      <span class="course-book-level-value">{{ bookLevel }}</span>
                    </div>
                    <h2 v-if="bookSubject" class="course-book-subject">{{ bookSubject }}</h2>
                  </li>
                  <template v-for="group in sectionGroups" :key="group.id">
                    <li><small>{{ group.title }}</small></li>
                    <li v-for="section in group.sections" :key="section.id" class="nav-item border-top">
                      <button type="button" class="nav-link text-dark" :class="{active: activeSectionId === section.id}"
                        :aria-pressed="activeSectionId === section.id" @click="OpenSection(section)">
                        <i :class="'bi bi-' + sectionIcon(section) + ' me-2'"></i>{{ section.title }}
                      </button>
                    </li>
                  </template>
                  <li v-if="!preview" class="nav-item border-top">
                    <div class="my-2">
                      
                      <button type="button" class="btn btn-sm btn-secondary me-2" @click="NoteOpenClose()"><i class="bi bi-pencil-square"></i> {{ noteVisible ? 'Ders Notumu Kapat' : 'Ders Notum' }}</button>
                      
                      
                    </div>
                    
                  </li>
                </ul>
              </div>
              <div class="course-workspace">
                <p v-if="detail && !visibleSections.length" class="text-muted">Bu ünite için yayınlanmış bölüm bulunmuyor.</p>
                <CourseContentHeader :title="activeTitle" />
                  <section class="pt-3 text-center" v-show="tabShow.tabAudioVisible">
                    <div v-if="audioDialogs.length>0">
                      <div v-for="(a,i) in audioDialogs" :key="i">
                        <small class="text-body-tertiary" v-html="(a.title!=null)?a.title:'Kitap içindeki diyalogları dinleyebilirsiniz.'"></small>
                        <audio v-bind:ref="'AudioPlayer'" v-bind:src="a.url" controls preload="none" controlsList="nodownload noplaybackrate" style="width:100%;" class="mt-1"></audio>
                      </div>

                    </div>
                    <div v-else class="text-center">
                      Ses dosyası hazırlanıyor.
                    </div>

                  </section>
                  <section class="pt-3" v-show="tabShow.tabVideoVisible">
                    <div v-if="videoLesson!=null">
                      <video ref="VideoPlayer" playsInline controls preload="none" controlsList="nodownload noplaybackrate" style="width: 100%;max-height: 560px;object-fit:contain;" >
                        <source v-bind:src="videoLessonUrl" type="video/mp4">
                      </video>
                    </div>
                    <div v-else class="text-center">
                      Video hazırlanıyor.
                    </div>
                  </section>
                  <section class="pt-3" v-show="tabShow.tabAnimationVideoVisible">
                    <div v-if="animationVideo!=null">
                      <video ref="AnimationVideoPlayer" playsInline controls preload="none" controlsList="nodownload noplaybackrate" style="width: 100%;max-height: 560px;object-fit:contain;" >
                        <source v-bind:src="animationVideoUrl" type="video/mp4">
                      </video>
                    </div>
                    <div v-else class="text-center">
                      Video hazırlanıyor.
                    </div>
                  </section>
                  <section v-if="!preview" id="lesson-notes" class="lesson-notes" v-show="noteVisible">
                    <div class="lesson-notes-header">
                      <div class="lesson-notes-title">
                        <span class="lesson-notes-icon"><i class="bi bi-journal-text" aria-hidden="true"></i></span>
                        <div><h2>Ders Notum</h2><p>Derse ait notlarını burada tutabilir ve düzenleyebilirsin.</p></div>
                      </div>
                      <button type="button" class="lesson-notes-close" @click="NoteOpenClose()"><i class="bi bi-x-lg" aria-hidden="true"></i><span>Kapat</span></button>
                    </div>
                    <TipTapEditor v-if="notesLoaded" :Description="scheduleLessonNote" @SaveLessonNote="SaveNoteLesson($event)"/>
                  </section>
                <TabLearnSubject v-if="activeTab === 'TabDialogs'" ref="dialogContent" :key="activeSectionId" :language="currentLang" :externalLanguageControl="true" @language="currentLang = $event" @language-availability="dialogTranslation = $event" :contents="dialogContents" :bookTitle="bookTitle" />
                <BookSectionContent v-if="activeTab === 'TabCustom'" ref="customContent" :key="activeSectionId" :contents="customContents" />
                <div v-show="activeTab !== 'TabCustom' && activeTab !== 'TabDialogs'" class="tab-content p-2" style="min-height: 400px;">
                  <div v-if="loadedTabs.tabSubjectVisible" class="tab-pane fade" :class="{'show active':tabShow.tabSubjectVisible}">
                    <TabLearnSubject ref="subjectContent" :language="currentLang" :externalLanguageControl="true" @language="currentLang = $event" @language-availability="subjectTranslation = $event" :contents="books" :bookTitle="bookTitle"/>
                  </div>
                  <div v-if="loadedTabs.tabReadingVisible" class="tab-pane fade" :class="{'show active':tabShow.tabReadingVisible}">
                    <TabLearnReading ref="readingContent" :language="currentLang" :externalLanguageControl="true" @language="currentLang = $event" @language-availability="readingTranslation = $event" :contents="books" :bookTitle="bookTitle"/>
                  </div>
                  <div v-if="loadedTabs.tabQuestionVisible" class="tab-pane fade" :class="{'show active':tabShow.tabQuestionVisible}">
                    <TabQuestion ref="questionContent" :questions="questions" :bookTitle="bookTitle" :section-image-url="questionsSectionImageUrl"/>
                  </div>
                  <div v-if="loadedTabs.tabWordVisible" class="tab-pane fade" :class="{'show active':tabShow.tabWordVisible}">
                    <TabLearnWordNew ref="wordContent" v-if="isNewWordView" :words="words.map(x => x.word)" :bookTitle="bookTitle" :section-image-url="wordsSectionImageUrl"/>
                    <TabLearnWord v-else :words="words" :bookTitle="bookTitle" :section-image-url="wordsSectionImageUrl"/>
                  </div>
                  <div v-if="loadedTabs.tabTeacherResultVisible" class="tab-pane fade" :class="{'show active':tabShow.tabTeacherResultVisible}">
                    <TabResultSubject :BookResult="bookResult" />
                  </div>
                  <div v-if="loadedTabs.tabTestVisible" class="tab-pane fade" :class="{'show active':tabShow.tabTestVisible}">
                    <TabTestSubject :BookTests="bookTest" :BookId="bookId"/>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
  <SaveNoteDialog v-if="!preview" 
  :ModalName="'SaveNote'"
  :ShowCloseButton="false"
  :Title="'Uyarı'"
  :Content="'Aldığınız notu kaydetmek istiyor musunuz?'" 
  :Visible="saveNoteDialogModalVisible" 
  @CloseModal="OpenCloseSaveNoteDialogModal($event)"
  @CustomDialogAnswer="SaveNoteDialogAnswer($event)"
  />
  <PostponeDialog v-if="!preview" 
  :ShowCloseButton="false"
  :Title="postponeDialogTitle"
  :Content="postponeDialogContent" 
  :Visible="postponeDialogModalVisible" 
  @CloseModal="OpenClosePostponeDialogModal($event)"
  @CustomDialogAnswer="PostponeDialogAnswer($event)"
  />
  <FooterInPage />
</template>

<script>
import { readScheduleState, scheduleQuery } from '@/common/schedule-navigation';
import BookSectionContent from '@/components/Course/Detail/BookSectionContent.vue';
import {visibleBookGroups, customSectionContents, pageSectionContents, dialogSectionContents, sectionTabs, sectionIcons} from '@/common/book-sections';
import CourseContentHeader from '@/components/Course/Detail/CourseContentHeader.vue';
import {mapActions } from "vuex";
import {resolveBookSectionLabels} from '@/common/book-section-labels';
import {DateFormat} from '@/common/datetime-helper'
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
import TipTapEditor from "@/components/TextEditors/Tiptap.vue"

import TabLearnSubject from "@/components/Course/Detail/tab-learn-subject.vue";
import TabLearnReading from "@/components/Course/Detail/tab-learn-reading.vue";
import TabLearnWord from "@/components/Course/Detail/tab-learn-word.vue";
import TabLearnWordNew from "@/components/Course/Detail/tab-learn-word-new.vue";
import TabTestSubject from "@/components/Course/Detail/tab-test-subject.vue";
import TabQuestion from "@/components/Course/Detail/tab-question.vue";
import TabResultSubject from "@/components/Course/Detail/tab-result-subject.vue";
import PostponeDialog from "@/components/Modals/CustomDialogModal.vue";
import SaveNoteDialog from "@/components/Modals/CustomDialogModal.vue";

import {LoadingToast,UpdateToast,ToastType} from "@/common/notification.js";
import {LevelText} from "@/common/enum-helper";
export default {
  name: 'CourseDetailPage',
  props: { preview: { type: Boolean, default: false } },
  components: {
    CourseContentHeader,
    BookSectionContent,
    NavBar,
    FooterInPage,
    TabLearnSubject,
    TabLearnWord,
    TabLearnWordNew,
    TabTestSubject,
    TabQuestion,
    TabResultSubject,
    TabLearnReading,
    PostponeDialog,
    SaveNoteDialog,
    TipTapEditor,
  },
  data() {
    return {
      detail : null,
      activeTab: '',
      activeSectionId: null,
      menuOpen: true,
      currentLang: 'en-EN',
      subjectTranslation: false,
      readingTranslation: false,
      dialogTranslation: false,
      time: 0,
      noteVisible:false,
      notesLoaded:false,
      loadedTabs:{},
      saveNoteDialogModalVisible:false,
      lessonNote:'',
      postponeDialogModalVisible:false,
      postponeDialogTitle:'Uyarı',
      postponeDialogConstContent:'<p>#LESSONDATE# tarihli dersinizi ertelemek istiyor musunuz?</p><strong>Not:</strong> Ders erteleme işlemini, ders saatinizden <strong class=text-danger><i>en az 2 saat önce</i></strong> yapabilirsiniz. Bunun dışında işlem <u>yapılmamaktadır.</u>',
      tabShow:{
          tabSubjectVisible:false,
          tabAudioVisible:false,
          tabVideoVisible:false,
          tabWordVisible:false,
          tabTestVisible:false,
          tabTeacherResultVisible:false,
          tabReadingVisible:false,
          tabAnimationVideoVisible:false,
          tabQuestionVisible:false,
      },
      animationVideoUrl:'',
      videoLessonUrl:''
    };
  },
  computed:{
    calendarReturnRoute() {
      return { path: '/lesson-schedule', query: scheduleQuery(readScheduleState(this.$route.query)) };
    },
    visibleSections() { return this.sectionGroups.flatMap(group => group.sections); },
    sectionGroups() {
      return visibleBookGroups(this.detail?.book, this.sectionLabels);
    },
    customContents() { return customSectionContents(this.detail?.book, this.activeSectionId); },
    dialogContents() { return dialogSectionContents(this.detail?.book, this.activeSectionId); },
    legacyContents() { return (this.detail?.book?.contents || []).filter(item => item.contentType !== 20); },
    activeTitle() {
      const active = this.visibleSections.find(section => section.id === this.activeSectionId);
      if (active) return active.title;
      const labels = { TabSubject: 'pages', TabReading: 'reading', TabWord: 'words', TabAudio: 'listening', TabVideo: 'video', TabAnimationVideo: 'animation', TabQuestion: 'questions', TabTest: 'test', TabTeacherResult: 'teacherEvaluation' };
      return this.sectionLabels[labels[this.activeTab]] || this.bookSubject || 'Ders';
    },
    canTranslate() {
      if (this.activeTab === 'TabDialogs') return this.dialogTranslation;
      return this.tabShow.tabReadingVisible ? this.readingTranslation : this.tabShow.tabSubjectVisible && this.subjectTranslation;
    },
    sectionLabels() {
      return resolveBookSectionLabels(this.detail?.book?.sectionLabels);
    },
    bookTitle:function(){
      let result={bookParentTitle:'',bookSubTitle:''};
      if(this.detail){
        result.bookParentTitle = this.detail.book.bookParentTitle;
        result.bookSubTitle = this.detail.book.bookSubTitle;
      }
      return result;
    },
    books:function(){
      let result=[];
      if(this.detail){
        result = pageSectionContents(this.detail.book);
      }
      return result;
    },
    audioDialogs:function(){
      let result=[];
      if(!this.detail){return result;}
      let contents = this.legacyContents.filter(x=>x.fileType===4)
      if(contents.length==0){return result;}
      
      for (let i = 0; i < contents.length; i++) {
        result.push({url:process.env.VUE_APP_ROOT_API+"Source/book/audio?fileName="+contents[i].fileName,title:contents[i].fileTitle});
      }
      return result;
    },
    videoLesson:function(){
      if(!this.detail){return null;}
      let content = this.legacyContents.find(x=>x.fileType===5 && x.contentType===4)
      if(!content){return null;}
      let url = process.env.VUE_APP_ROOT_API+"Source/book/video?fileName="+content.fileName;
      return url;
    },
    animationVideo:function(){
      if(!this.detail){return null;}
      let content = this.legacyContents.find(x=>x.fileType===5 && x.contentType===7)
      if(!content){return null;}
      
      let url = process.env.VUE_APP_ROOT_API+"Source/book/video?fileName="+content.fileName;
      return url;
    },
    wordsSectionImageUrl() {
      const fileName = this.detail?.book?.wordsSectionImageFileName?.trim();
      return fileName ? process.env.VUE_APP_ROOT_API + 'Book/SectionImage?fileName=' + encodeURIComponent(fileName) : '';
    },
    questionsSectionImageUrl() {
      const fileName = this.detail?.book?.questionsSectionImageFileName?.trim();
      return fileName ? process.env.VUE_APP_ROOT_API + 'Book/SectionImage?fileName=' + encodeURIComponent(fileName) : '';
    },
    words:function(){
      let result=[];
      if(this.detail){
        result = this.detail.book.words;
      }
      return result;
    },
    questions:function(){
      let result=[];
      if(this.detail){
        result = this.detail.book.questions;
      }
      return result;
    },
    bookLevel:function(){
      let result = null;
      if(this.detail){
        result = LevelText(this.detail.book.level);
      }
      return result
    },
    isPagesView : function(){
      let result = true;
      if(this.detail){
        const allowedTypes = [10, 11, 12, 1, 2, 3, 6];
        result = this.books.some(item => allowedTypes.includes(item.contentType))
      }
      return result
    },
    isNewWordView:function(){
      let result = null;
      if(this.detail){
        result = this.detail.book.isNewWordView;
      }
      return result
    },
    bookId:function(){
      let result = null;
      if(this.detail){
        result = this.detail.book.id;
      }
      return result
    },
    bookSubject:function(){
      let result = null;
      if(this.detail){
        result = this.detail.book.subject;
      }
      return result
    },
    scheduleLessonNote:function(){
      let result = null;
      if(this.detail && this.detail.lessonNote){
        result = this.detail.lessonNote;
      }
      return result
    },
    bookResult:function(){
      let result = null;
      if(this.detail && this.detail.result){
        result = this.detail.result;
      }
      return result
    },
    bookTest:function(){
      let result = null;
      if(this.detail){
        result = this.detail.book.tests;
      }
      return result
    },
    reading:function(){
        if(this.books.length>0)
        {
            let find = this.books.find(x=>x.contentType===13);
            if(find){
                return true;
            }
        }
        return false;
    },
    lessonDate:function(){
      let result = null;
      if(this.detail && this.detail.lessonDate){
        result = this.detail.lessonDate;
      }
      return result
    },
    trainingFileId:function(){
      let result = null;
      if(this.detail && this.detail.trainingFileId){
        result = this.detail.trainingFileId;
      }
      return result
    },
    lessonStatus:function(){
      let result = 0;
      if(this.detail && this.detail.status){
          result = this.detail.status;
      }
      return result;
    },
    isPostponed:function(){
      let result = false;
      if(this.detail && this.detail.status){
        result = this.detail.status==3;
      }
      return result
    },
    isPostponeButtonDisable:function(){
      return !this.lessonStatus==0
    },
    postponeDialogContent:function(){
        return this.postponeDialogConstContent.replace('#LESSONDATE#',DateFormat(this.lessonDate,'dd.mm.yyyy'));
    },
    postponeDateView:function(){
      return DateFormat(this.lessonDate,'dd.mm.yyyy')
    }
  },
  methods: {
    ...mapActions(["GetBookDetail","GetSimpleBookDetail","PostponeLesson","SaveLessonNote"]),
    async init(){
      let toastId = LoadingToast();
      let form = {code:this.$route.params.id};
      await (this.preview ? this.GetSimpleBookDetail(this.$route.query.id) : this.GetBookDetail(form))
      .then((res)=>{
        this.detail = this.preview ? { book: res, result: res.result } : res;
        const first = this.sectionGroups.flatMap(group => group.sections)[0];
        if (first) this.OpenSection(first, false);
        UpdateToast(toastId,res.description,ToastType().SUCCESS,100);
      })
      .catch((err)=>{
        UpdateToast(toastId,err.message,ToastType().ERROR);
      });
    },
    async PostponeLessonProcess() {
        let toastId = LoadingToast();
        let model = {
            trainingFileId: this.trainingFileId,
            lessonDate: this.lessonDate
        }
        await this.PostponeLesson(model)
        .then((res) => {
          UpdateToast(toastId,res.description,ToastType().SUCCESS);
        })
        .catch((err) => {
          UpdateToast(toastId,err.message,ToastType().ERROR);
        });
    },
    OpenClosePostponeDialogModal(visible){
      this.postponeDialogModalVisible=visible;
    },
    PostponeDialogAnswer(answer){
      if(answer){
        this.PostponeLessonProcess();
      }
    },
    OpenCloseSaveNoteDialogModal(visible){
      this.saveNoteDialogModalVisible=visible;
    },
    SaveNoteDialogAnswer(answer){
      if(answer){
        let toastId = LoadingToast();
        let model = {
            code:this.$route.params.id,
            lessonNote: this.lessonNote
        }
        this.SaveLessonNote(model)
        .then((res) => {
          UpdateToast(toastId,res.description,ToastType().SUCCESS);
        })
        .catch((err) => {
          UpdateToast(toastId,err.message,ToastType().ERROR);
        });
      }
    },
    sectionIcon(section) { return sectionIcons[section.rendererType] || 'file-earmark-text'; },
    OpenSection(section, closeMenu = true) {
        this.$refs.customContent?.stopMedia();
        this.activeSectionId = section.id;
        this.OpenTab(sectionTabs[section.rendererType], closeMenu);
    },
    OpenTab(value, closeMenu = true){
        this.$refs.dialogContent?.stopAudio();
        this.activeTab = value;
        if (closeMenu) this.menuOpen = false;
        this.$refs.subjectContent?.stopAudio();
        this.$refs.readingContent?.stopAudio();
        this.$refs.wordContent?.stopAudio();
        this.$refs.questionContent?.stopAudio();
        this.tabShow.tabSubjectVisible=false;
        this.tabShow.tabAudioVisible=false;
        this.tabShow.tabVideoVisible=false;
        this.tabShow.tabWordVisible=false;
        this.tabShow.tabQuestionVisible=false;
        this.tabShow.tabTestVisible=false;
        this.tabShow.tabTeacherResultVisible=false;
        this.tabShow.tabReadingVisible=false;
        this.tabShow.tabAnimationVideoVisible=false;
        
        if(this.$refs.AudioPlayer){
          for(let i=0;i<this.$refs.AudioPlayer.length;i++){
            this.$refs.AudioPlayer[i].pause();
          }
        }
        
        if(this.$refs.VideoPlayer){
          this.$refs.VideoPlayer.pause();
        }

        if(this.$refs.AnimationVideoPlayer){
          this.$refs.AnimationVideoPlayer.pause();
        }

        if(value==='TabSubject'){
          this.tabShow.tabSubjectVisible=true;
        } else if(value==='TabAudio'){
          this.tabShow.tabSubjectVisible=true;
          this.tabShow.tabAudioVisible=true;
        } else if(value==='TabVideo'){
          this.tabShow.tabSubjectVisible=true;
          this.tabShow.tabVideoVisible=true;
          this.videoLessonUrl=this.videoLesson;
          this.$nextTick(() => {
            this.$refs.VideoPlayer?.load();
          });
        } else if(value==='TabWord'){
          this.tabShow.tabWordVisible=true;
        } else if(value==='TabQuestion'){
          this.tabShow.tabQuestionVisible=true;
        } else if(value==='TabTest'){
          this.tabShow.tabTestVisible=true;
        } else if(value==='TabTeacherResult'){
          this.tabShow.tabTeacherResultVisible=true;
        } else if(value==='TabReading'){
          this.tabShow.tabReadingVisible=true;
        } else if(value==='TabAnimationVideo'){
          this.tabShow.tabSubjectVisible=true;
          this.tabShow.tabAnimationVideoVisible=true;
          this.animationVideoUrl=this.animationVideo;
          this.$nextTick(() => {
            this.$refs.AnimationVideoPlayer?.load();
          });
        }
        // Keep visited panes mounted so answers and local state survive navigation.
        Object.keys(this.tabShow).forEach(key => {
          if (this.tabShow[key]) this.loadedTabs[key] = true;
        });
    },
    NoteOpenClose(){
      this.notesLoaded = true;
      this.menuOpen = false;
      if(this.noteVisible)
        this.noteVisible=false;
      else
        this.noteVisible=true;
    },
    SaveNoteLesson(value){
      this.lessonNote=value;
      this.OpenCloseSaveNoteDialogModal(true);
    }

  },
  mounted: async function () {
      await this.init();
    }
}
</script>
<style scoped>
.calendar-return { display: inline-flex; align-items: center; gap: 6px; margin-bottom: 14px; padding: 0; border: 0; background: transparent; color: var(--brand-link); font-size: 13px; font-weight: 600; text-decoration: none; }
.calendar-return:hover { color: var(--brand-primary-hover); text-decoration: underline; text-underline-offset: 3px; }
.calendar-return:focus-visible { outline: 3px solid var(--brand-focus); outline-offset: 3px; }
.course-page { max-width: 1480px; padding: 28px 24px 48px; background: #f6f8fa; min-height: 70vh; }
.course-page > .row > .col-12 > .card { background: transparent; }
.course-page .card-body { padding: 0; }
.course-layout { display: grid; grid-template-columns: 288px minmax(0, 1fr); gap: 24px; align-items: start; }
.course-sidebar { position: sticky; top: 20px; background: #fff; border: 1px solid #e8edf1; border-radius: 18px; padding: 16px; max-height: calc(100vh - 40px); overflow-y: auto; }
.course-sidebar .border-top { border: 0 !important; }
.course-book-summary { min-width: 0; margin: 0 4px 8px; padding: 8px 8px 20px; border-bottom: 1px solid #e8edf1; }
.course-book-level { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px 12px; }
.course-book-label { color: #697586; font-size: 12px; font-weight: 500; }
.course-book-level-value { max-width: 100%; padding: 5px 10px; border: 1px solid #dcebe3; border-radius: 8px; background: #f0f7f3; color: #285943; font-size: 12px; font-weight: 600; line-height: 1.4; overflow-wrap: anywhere; }
.course-book-subject { margin: 14px 0 0; color: #20382d; font-size: 16px; font-weight: 600; line-height: 1.5; overflow-wrap: anywhere; }
.course-sidebar .nav-link { width: 100%; text-align: left; border: 0; background: transparent; border-left: 4px solid transparent; border-radius: 0 12px 12px 0; padding: 12px; color: #536174 !important; transition: background .15s; }
.course-sidebar .nav-link:hover { background: #f5f8fa; }
.course-sidebar .nav-link.active { background: #ecfdf5; border-left-color: #10b981; color: var(--brand-primary-hover) !important; font-weight: 600; }
.course-sidebar li > small { display: block; margin: 20px 12px 8px; color: #697586; font-weight: 600; }
.course-sidebar button:focus-visible { outline: 3px solid var(--brand-primary); outline-offset: 2px; }
.course-workspace { min-width: 0; background: white; border: 1px solid #e8edf1; border-radius: 18px; padding: 24px; }
.course-workspace > section { margin-bottom: 20px; }
.lesson-notes { background: #f8faf9; border: 1px solid #e2ebe6; border-radius: 16px; padding: 24px; }
.lesson-notes-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 20px; }
.lesson-notes-title { display: flex; align-items: flex-start; gap: 12px; min-width: 0; }
.lesson-notes-icon { display: grid; place-items: center; width: 42px; height: 42px; flex-shrink: 0; background: #e8f3ed; color: var(--brand-primary); border-radius: 12px; font-size: 20px; }
.lesson-notes-title h2 { margin: 0 0 6px; font-size: 18px; font-weight: 600; color: #20382d; }
.lesson-notes-title p { margin: 0; font-size: 13px; line-height: 1.6; color: #64748b; }
.lesson-notes-close { display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0; border: 0; border-radius: 8px; padding: 8px 10px; background: transparent; color: #64748b; font-size: 13px; }
.lesson-notes-close:hover { background: #eaf0ed; color: #20382d; }
.lesson-notes-close:focus-visible { outline: 3px solid var(--brand-primary); outline-offset: 2px; }
.lesson-notes :deep(.note-editor-frame) { padding: 0 !important; margin-bottom: 14px !important; background: #fff; border-color: #e2e8f0 !important; border-radius: 12px !important; overflow: hidden; }
.lesson-notes :deep(.note-editor-toolbar) { justify-content: flex-start !important; margin-bottom: 0 !important; padding: 10px 12px; background: #fcfdfc; border-bottom: 1px solid #edf2ef; }
.lesson-notes :deep(.note-editor-toolbar .btn-group) { flex-wrap: wrap; gap: 4px; }
.lesson-notes :deep(.note-editor-toolbar .btn) { border: 0; border-radius: 6px !important; }
.lesson-notes :deep(.note-editor-viewport) { height: 180px !important; padding: 16px; font-size: 15px; line-height: 1.7; color: #334155; }
.lesson-notes :deep(.note-editor-save) { border-radius: 9px; padding: 9px 20px; font-weight: 600; }
@media (max-width: 575px) {
  .lesson-notes { padding: 16px; }
  .lesson-notes-header { gap: 8px; }
  .lesson-notes-icon { display: none; }
  .lesson-notes-close { padding: 6px 8px; }
  .lesson-notes :deep(.note-editor-save) { width: 100%; }
}
.course-workspace video { border-radius: 12px; background: #14251f; }
.course-menu-toggle { display: none; }
@media (max-width: 991px) {
  .course-page { padding: 16px 12px 32px; }
  .course-layout { grid-template-columns: minmax(0, 1fr); gap: 16px; }
  .course-sidebar { position: static; max-height: none; padding: 8px; }
  .course-menu-toggle { display: block; width: 100%; text-align: left; }
  .course-sidebar .nav { display: none; }
  .course-sidebar .nav.is-open { display: flex; }
  .course-workspace { padding: 16px; }
}
</style>
